import { useEffect, useState } from 'react';
import './moreBtn.scss';
import imgUrlFocus from '../../../assets/img/chakan_h.png';
import imgUrlBlur from '../../../assets/img/chakan_s.png';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function posterForColumn(props) {
  const [posterInfo, updatePosterInfo] = useState({
    isChecked: false,
    isFocus: props.posterBox.posterArr.isFocus,
    indexValue: 0,
    posterAtion: undefined,
  });

  useEffect(() => {
    const {
      posterBox: { posterAnimation, posterIndex, posterArr: { isFocus } },
      isChecked,
    } = props;
    updatePosterInfo({
      isChecked,
      isFocus,
      indexValue: posterIndex,
      posterAtion: posterAnimation,
    });
  }, []);

  useEffect(() => {
    const {
      posterBox: { posterArr },
      // flag,
      isChecked,
    } = props;
    updatePosterInfo(posterInfo => ({
      ...posterInfo,
      isChecked,
      isFocus: posterArr.isFocus,
    }));
  }, [props.isChecked, props.posterBox.posterArr.isFocus]);

  const { t } = useTranslation();

  return (
    <Link to={'/filterPage/0'} style={{ color: 'transparent' }}>
      <div
        className={[
          'moreBtnBox',
          posterInfo.posterAtion === posterInfo.indexValue ? 'moreBtnShake' : null,
        ].join(' ')}
      >
        <img className="moreBtnImg" src={posterInfo.isFocus && posterInfo.isChecked ? imgUrlFocus : imgUrlBlur} alt="" />
        <span className="moreBtnTitle">{t('查看更多')}</span>
      </div>
    </Link>
  );
}
